import React from 'react';
import {withStyles} from '@mui/styles';
import {East, West} from "@mui/icons-material";
import ColorGrid from "./ColorGrid";

const styles = {
  colorGridContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1px",
    margin: "0 auto",
  },
  colorGridContainerMain: {
    display: "flex",
    flexDirection: "row",
    gap: "1px",
    padding: "2px",
  },
  gridLabelH:{
    flexGrow: 1,
    height: "2em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5em",
    fontSize: "0.85rem",
    margin: "0 32px 0 37px",
    whiteSpace: "nowrap",
    "& > svg":{
      fontSize: "inherit",
      width: "1.25em",
      height: "1.25em",
      opacity: 0.65,
    },
  },
  gridLabelV:{
    verticalAlign: "middle",
    display: "flex",
    alignItems: "center",
    width: "2em",
    zIndex: 0,
    margin: "0 2.5em 0 -2em",
    fontSize: "0.85rem",
  },
  gridLabelVInner:{
    display: "flex",
    alignItems: "center",
    transform: "rotate(-90deg) translate(-50%, 2.75rem)",
    transformOrigin: "0 center",
    justifyContent: "center",
    height: "2em",
    zIndex: 0,
    gap: "0.5em",
    whiteSpace: "nowrap",
    "& > svg":{
      fontSize: "inherit",
      width: "1.25em",
      height: "1.25em",
      opacity: 0.65,
    },
  },
  gridValueLabel:{
    height: "1.75rem",
    width: "1.75rem",
    border: "1px solid #0000",
    borderRadius: "2px",
    margin: "1px",
    fontSize: "0.7225rem",
    verticalAlign: "middle",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.0625s ease-out",
  },
  colorGridWrap: {
    display: "flex",
    boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
    border: "1px solid rgba(0,0,0,0.12)",
    borderRadius: "4px",
    padding: "2px",
    zIndex: 1,
    backgroundColor: "#fff",
  },
}

function ResultsGrid(props) {
  const {surveyAttempt, classes} = props;
  const xChoices = surveyAttempt.survey.options.choices[0];
  const yChoices = surveyAttempt.survey.options.choices[1] || {};
  const yCount = yChoices?.answers?.length || 1;

  return (
    <div className={classes.colorGridContainer}>
      <div className={classes.gridLabelH}>
        {!xChoices?.label ? null :
          <><West />{xChoices.label}<East /></>
        }
      </div>
      <div className={classes.colorGridContainerMain}>
        <div className={classes.gridLabelV}>
          {!yChoices?.label ? null :
            <div className={classes.gridLabelVInner}><West />{yChoices.label}<East /></div>
          }
        </div>
        <div className={classes.colorGridWrap}>
          <ColorGrid surveyAttempt={surveyAttempt} fixedWidth />
        </div>
        <div className={classes.gridLabelV} style={{margin: "3px 2px", gap: "1px", flexDirection: "column-reverse", width: "unset"}}>
          {new Array(yCount).fill(0).map((_, i) =>
            <div key={`label_${i}`} className={classes.gridValueLabel} />
          )}
        </div>
      </div>
    </div>
  );
}

export default withStyles(styles)(ResultsGrid);